export enum BusinessProspectType {
    RequestInfo,
    PaymentAttempt,
}
